import { Component, Input, OnInit } from '@angular/core';
import { CallNumber } from '@awesome-cordova-plugins/call-number/ngx';
import { InAppBrowser, InAppBrowserObject } from '@awesome-cordova-plugins/in-app-browser/ngx';
import { Capacitor } from '@capacitor/core';
import { NavController, ToastController } from '@ionic/angular';
import { Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';

import { AppSettings } from '../../../../app.settings';
import { SharedAnalyticsService } from '../../../../shared/analytics/shared-analytics/shared-analytics.service';
import { GTMEventsCrash } from '../../../../shared/enums/Crashlytics';
import { IGNORE } from '../../../../shared/enums/versiones';
import { ISendSelectNotificationParams } from '../../../../shared/models/Analytics';
import { EventInteraction, GTMInteractions } from '../../../../shared/models/Constants';
import { INotificationsData } from '../../../../shared/models/NotificacionTendero';
import { AnalyticsService } from '../../../../shared/services/analytics.service';
import { CrashlyticsService } from '../../../../shared/services/crashlytics/crashlytics.service';
import { UtilitiesService } from '../../../../shared/services/utilities/utilities.service';
import { readNotification, setReadNotification } from '../../../../store/actions';
import { AppState } from '../../../../store/app-reducers';
import { StorageData } from './../../../../shared/services/utilities/storage-data.class';

@Component({
  selector: 'app-cards-rounded',
  templateUrl: './cards-rounded.component.html',
  styleUrls: ['./cards-rounded.component.scss'],
})
export class CardsRoundedComponent implements OnInit {

  @Input() item: any = null;
  @Input() page: string = '';

  public actualNotification: INotificationsData = {} as INotificationsData;

  constructor(
    private analyticsS: AnalyticsService
    , private sharedAnalyticsS: SharedAnalyticsService
    , private crashlytics: CrashlyticsService
    , private nav: NavController
    , private callNumber: CallNumber
    , private toast: ToastController
    , private inAppBrowser: InAppBrowser
    , private store: Store<AppState>
    , private translate: TranslateService
    , private utilS: UtilitiesService
  ) { }

  ngOnInit() {
  }

  public async notificationClicked(notification: INotificationsData) {
    const { idCatProvider, offset, pageSize }: { idCatProvider: number; offset: number; pageSize: number; } = this.translate.instant('Miscellaneous.PushParams');
    const jwt = await StorageData.getDataStorage(AppSettings.JWT_L);
    const decodeToken = this.utilS.getDecodeTokenJwt(jwt);
    const idUser = decodeToken.ID_Tendero;
    if (!notification.view) {
      this.store.dispatch(readNotification({ idPushDetail: notification.idPushDetail, idCatProvider, offset, pageSize, idUser, idVersion: notification.idVersion }));
      this.store.dispatch(setReadNotification({ ID_NotificacionTendero: notification.idPushDetail }));
    }
    const isIgnore = await IGNORE();
    const ruta = isIgnore && notification.metadata.ruta.includes('Juegos') ? '/Notificationes' : notification.metadata.ruta;
    this.nav.navigateForward([ruta], { animated: true, animationDirection: 'forward' });

    const params: ISendSelectNotificationParams = {
      title: `${this.analyticsS.normalizeText(notification.title)} ${notification.idPushDetail}`
    }
    this.sharedAnalyticsS.sendSelectNotification(params);
  }

  public async llamar(telefono: string) {

    const etiqueta = this.item['Tipo'] === 'ayuda' ? 'numero_telefonico_ayuda' : 'numero_telefonico_ganadores'

    const event: any = { ...GTMInteractions.contactLineCallEvent }
    event.fbEvent.data_etiqueta = etiqueta
    event.gtmEvent.etiqueta = etiqueta
    this.analyticsS.sendEventAnalytics(event, EventInteraction)

    try {
      const formattedPhone = telefono.replace(/ /g, '');
      if (Capacitor.getPlatform() === 'android') {
        await this.callNumber.callNumber(formattedPhone, false);
      } else {
        window.location.href = `tel:${formattedPhone}`;
      }
    } catch (error) {
      this.presentToast('Error al realizar la llamada');
      this.crashlytics.sendCrashPlatform(GTMEventsCrash.callNumberContactPlugin, error);
    }
  }

  private async presentToast(message: any) {
    const toast = await this.toast.create({
      message,
      duration: 3000,
      mode: 'md'
    })
    toast.present()
  }

  public openUrl(UrlWeb: string) {
    // TODO JAIR: VALIDAR INTERACCION
    this.analyticsS.fbAnalytics('interacciones', { data_categoria: 'linea_contacto', data_accion: '/Contacto', data_etiqueta: 'url_gepp' })

    const browser: InAppBrowserObject = this.inAppBrowser.create(UrlWeb, '_system')
  }

}
